import {
    Calendar,
    Clock,
    MapPin,
} from "lucide-react";

import {
    formatDisplayDate
} from "../../utils/timeUtils";

import {
    getStatusColor,
    SPORT_CONFIG,
} from "../../utils/orderUtils";

import {
    mergeContinuousSlots
} from "../../utils/bookingUtils";

function OrderHistoryCard({
    booking
}) {

    const statusStyle =
        getStatusColor(
            booking.bookingStatus
        );

    const createdAtText =

        booking.createdAt?.toDate

            ? booking.createdAt
                .toDate()
                .toLocaleString()

            : "";

    const mergedSlots =
        mergeContinuousSlots(
            booking.slots || []
        );

    return (

        <div style={styles.card}>

            {/* HEADER */}

            <div style={styles.header}>

                <div>

                    <h3 style={styles.bookingId}>

                        Order #

                        {" "}

                        {booking.bookingId}

                    </h3>

                    <div style={styles.orderMeta}>

                        Ordered on

                        {" "}

                        {createdAtText}

                    </div>

                    <div style={styles.statusRow}>

                        <div
                            style={{
                                ...styles.status,

                                background:
                                    statusStyle.bg,

                                border:
                                    `1px solid ${statusStyle.border}`,

                                color:
                                    statusStyle.text,
                            }}
                        >

                            {booking.bookingStatus}

                        </div>

                    </div>

                </div>

                <div style={styles.total}>

                    $
                    {booking.totalAmount}

                </div>

            </div>

            {/* SLOTS */}

            <div style={styles.slots}>

                {mergedSlots.map(

                    (
                        slot,
                        index
                    ) => {

                        const sportConfig =
                            SPORT_CONFIG[
                            slot.sport
                            ];

                        return (

                            <div
                                key={`${slot.courtName}_${slot.date}_${index}`}
                                style={styles.slotCard}
                            >

                                {/* TOP */}

                                <div style={styles.slotTop}>

                                    <div>

                                        <h4 style={styles.courtName}>
                                            {slot.courtName}
                                        </h4>

                                        {sportConfig && (

                                            <div
                                                style={{
                                                    ...styles.sportText,

                                                    color:
                                                        sportConfig.color,
                                                }}
                                            >

                                                {sportConfig.emoji}

                                                {" "}

                                                {sportConfig.label}

                                            </div>
                                        )}

                                    </div>

                                    <div style={styles.price}>

                                        $
                                        {slot.price}

                                    </div>

                                </div>

                                {/* META */}

                                <div style={styles.metaGrid}>

                                    <div style={styles.metaItem}>

                                        <Calendar
                                            size={14}
                                        />

                                        <span>

                                            {formatDisplayDate(
                                                slot.date
                                            )}

                                        </span>

                                    </div>

                                    <div style={styles.metaItem}>

                                        <Clock
                                            size={14}
                                        />

                                        <span>

                                            {slot.timeSlot}

                                            {" "}

                                            (

                                            {slot.duration}h

                                            )

                                        </span>

                                    </div>

                                    <div style={styles.metaItem}>

                                        <MapPin
                                            size={14}
                                        />

                                        <span>
                                            {slot.location}
                                        </span>

                                    </div>

                                </div>

                            </div>
                        );
                    }
                )}

            </div>

        </div>
    );
}

const styles = {

    card: {

        background:
            "rgba(0,40,70,0.72)",

        border:
            "1px solid rgba(0,255,136,0.15)",

        borderRadius:
            "24px",

        padding:
            "24px",

        backdropFilter:
            "blur(10px)",
    },

    header: {

        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "center",

        marginBottom:
            "20px",

        gap:
            "16px",
    },

    bookingId: {

        color:
            "#fff",

        margin:
            0,

        marginBottom:
            "6px",
    },

    orderMeta: {

        color:
            "#cbd5e1",

        fontSize:
            "13px",

        marginBottom:
            "10px",
    },

    statusRow: {

        display:
            "flex",
    },

    status: {

        padding:
            "6px 12px",

        borderRadius:
            "999px",

        fontSize:
            "12px",

        fontWeight:
            "700",

        textTransform:
            "capitalize",
    },

    total: {

        color:
            "#00ff88",

        fontSize:
            "28px",

        fontWeight:
            "800",
    },

    slots: {

        display:
            "flex",

        flexDirection:
            "column",

        gap:
            "14px",
    },

    slotCard: {

        background:
            "rgba(255,255,255,0.04)",

        borderRadius:
            "16px",

        padding:
            "16px",
    },

    slotTop: {

        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "center",

        marginBottom:
            "12px",
    },

    courtName: {

        color:
            "#fff",

        margin:
            0,

        marginBottom:
            "4px",
    },

    sportText: {

        fontSize:
            "13px",

        fontWeight:
            "700",
    },

    price: {

        color:
            "#00ff88",

        fontWeight:
            "700",
    },

    metaGrid: {

        display:
            "grid",

        gridTemplateColumns:
            "repeat(auto-fit, minmax(180px, 1fr))",

        gap:
            "12px",
    },

    metaItem: {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "8px",

        color:
            "#d1d5db",

        fontSize:
            "14px",
    },
};

export default OrderHistoryCard;